import { Outlet } from 'react-router';

import { ThemeSwitch } from '@/components/ThemeSwitch';
import { texts } from '@/lib/texts';

import { useAdmin } from './AuthGuard';

/**
 * Оболочка портала площадки (BLUEPRINT Stage 14, задача 2): у роли `VENUE` нет разделов
 * админки — только свои брони, поэтому сайдбар заменён узкой шапкой.
 *
 * Раунд 4, V9: «Портал площадки» стоит в шапке один раз (заголовок страницы — «Брони»);
 * на телефоне переключатель темы — второй строкой во всю ширину, «Выйти» — кнопкой в 44 px.
 */
export function VenueLayout() {
  const { me, signOut } = useAdmin();

  return (
    <div className="min-h-screen">
      <header className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-b border-border bg-surface px-4 py-3 sm:px-6">
        <div className="min-w-0">
          <div className="text-lg font-bold tracking-tight">{texts.app.short}</div>
          <div className="text-xs text-muted">{texts.venuePortal.title}</div>
        </div>
        <div className="flex min-w-0 items-center gap-3 sm:order-last sm:gap-4">
          <div className="min-w-0 truncate text-right text-sm font-medium">
            {me.firstName} {me.lastName ?? ''}
          </div>
          <button
            type="button"
            onClick={() => void signOut()}
            className="text-accent-dark min-h-11 rounded-lg border border-input px-3 text-sm font-semibold hover:bg-surface-2 sm:min-h-0 sm:border-transparent sm:px-1 sm:text-xs sm:hover:underline"
          >
            {texts.auth.logout}
          </button>
        </div>
        <ThemeSwitch touch className="w-full sm:ml-auto sm:w-auto" />
      </header>
      {/* Раунд 3, V2: на телефоне поля в 32 px съедали место у карточек броней */}
      <main className="min-w-0 px-4 py-5 sm:px-6 lg:px-8 lg:py-8">
        <Outlet context={useAdmin()} />
      </main>
    </div>
  );
}
